import React, { useCallback } from 'react';

import { Badge } from 'twyne-new.ui'

import SelectDropdown from './SelectDropDown';

export default function FontWeightFormatter({ editor }) {
  const value = editor.getTailwindValue({ name: 'fontWeight' })?.value
  const handleClickOption = useCallback(fontWeight => editor.commands.setFontWeight(value === fontWeight ? null : fontWeight), [editor, value])

  return <SelectDropdown
    options={WEIGHTS}
    onChange={handleClickOption}
    tooltipText='Font Weight'
    value={value}
    menuFitContent
    formatOptionLabel={formatOptionLabel}
  />
}

const formatOptionLabel = ({ value, label }) => <span className='flex items-center gap-2'>
  {label}
  <Badge size='sm' variant='light' className='self-center'>{value}</Badge>
</span>

const WEIGHTS = [
  { value: '100', label: 'Thin' },
  { value: '200', label: 'Extra light' },
  { value: '300', label: 'Light' },
  { value: '400', label: 'Normal' },
  { value: '500', label: 'Medium' },
  { value: '600', label: 'Semi bold' },
  { value: '700', label: 'Bold' },
  { value: '800', label: 'Extra bold' },
  { value: '900', label: 'Black' },
]
